define([
	"dojo/_base/declare",
	"csi",
	"csi/locale",
	"csi/reflection",
	"csi/service/nodeService",
	"csi/types",
	"csi/xml",
	"SiteAdmin/BusinessObject",
	"SiteAdmin/Locale",
	"src/c8-platform/type/uom"
], function(declare, csi, locale, reflection, {resolveNodes}, types, xml, BusinessObject, Locale, {UOM_SUFFIX}) {

	var FG_READONLY = "FlagReadOnly",
		DESTINATION_CLASS_NAMES_WITH_SUBTYPE_ATTR_ID = {
			"SpecificationItemDefinition": "Subtype",
			"LookupItem": "Subtype"
		};
	const COLUMNWIDTH_TYPE = "ColumnWidthType";

	return declare(null, {
		// String: initial value error code to look for
		ivErrorCode: null,

		getAttributeFlags: function(/*FormData*/fd) {
			// summary: return attribute flags from form
			return fd.getFieldValue(FG_READONLY, true) ? xml.ATTR_FLAG_NOEDIT : 0;
		},

		/**
		 * Process the "ColumnWidth" attribute, determine whether ignore the "ColumnWidth" or not
		 * @param {FormData} fd
		 * @param {boolean} bEdit
		 */
		_handleColumnWidth: function(fd, bEdit) {
			const form = this.popupView;
			const type = fd.getFieldValue(reflection.ATTR_VALUETYPE);
			const format = fd.getFieldValue(reflection.ATTR_FORMAT);
			const selectedColumnWidth = fd.getFieldValue(reflection.ATTR_COLUMN_WIDTH);
			const attributeID = fd.getFieldValue(xml.ATTR_NAME);

			const defaultColumnWidth = types.getAttributeDefaultColumnWidth(attributeID, type, format);
			const keepDefaultEnum = xml.enumCreate(COLUMNWIDTH_TYPE, "");

			let ignore = (selectedColumnWidth === defaultColumnWidth);

			if (bEdit && selectedColumnWidth === defaultColumnWidth) {
				form.setFieldValue(reflection.ATTR_COLUMN_WIDTH, keepDefaultEnum);
				ignore = false;
			}

			fd.getFieldValue(reflection.ATTR_COLUMN_WIDTH, ignore);
		},

		changeSubtypeAndFormat: function(/*ChangeNode*/cn, /*String*/attrType) {
			// summary: write attributes related to subtypes/references
			var fd = this.m_formData;

			var bRef = xml.attributeTypeIsRef(attrType);
			var targetClassName = fd.getFieldValue(BusinessObject.ATTR_TARGET_CLASS_NAME);

			var subtypeAttrId = DESTINATION_CLASS_NAMES_WITH_SUBTYPE_ATTR_ID[targetClassName];
			cn.changeAttribute(BusinessObject.ATTR_TARGET_CLASS_SUBTYPE_ATTRIBUTE_ID, xml.ATTR_STRING, subtypeAttrId || "");

			if (!subtypeAttrId) {
				// Form will not submit empty selection, because field is hidden in that case
				cn.changeAttribute(reflection.ATTR_SUBTYPE, xml.ATTR_REF, csi.EMPTY_URL);
			}

			if (bRef) {
				var formatForRef = (targetClassName == "Image") ? "Image" : (targetClassName == "Tag") ? "Tag" : "";
				cn.changeAttribute(reflection.ATTR_FORMAT, xml.ATTR_STRING, formatForRef);
			}
		},

		toWriterLocale: function(/*Boolean*/bValidate, /*UOMConversionId | UOMName*/uomId = null, /*String*/suffix = "") {
			var w = this.m_writer;
			var fd = this.m_formData;
			var nodeCA = this.getNode();
			var b, id, typeClass;

			if (nodeCA) {
				id = uomId === null ? Locale.getConfigurableAttributeId(nodeCA) : uomId;
				typeClass = Locale.getConfigurableAttributeType(nodeCA);
			} else {
				id = uomId === null ? fd.getFieldValue(xml.ATTR_NAME) : uomId;
				typeClass = fd.getFieldValue(reflection.ATTR_REFLECTION_ATTR_OWNER);
				if (!typeClass) {
					typeClass = BusinessObject.getAttributeType(fd.getSource().getParent());
				}
			}

			var keysValidate = [typeClass, Locale.TYPE_ATTR, id + Locale.ATTR_VALIDATION];

			f = fd.getField("LocaleName");
			if (f && f.isUpdated()) {
				Locale.setResource(w, Locale.ATTR_TYPES, [typeClass, Locale.TYPE_ATTR, id], f.getValue() + suffix, null, true);
				b = true;
			}

			f = fd.getField("LocaleTooltip");
			if (f && f.isUpdated() && this._isRegularAttribute(uomId, id)) {
				Locale.setResource(w, Locale.ATTR_TYPES, [typeClass, Locale.TYPE_ATTR, id + Locale.TOOLTIP], f.getValue(), null, true);
				b = true;
			}

			f = fd.getField("LocaleValidation");
			if (f && f.isUpdated() && this._isRegularAttribute(uomId, id)) {
				Locale.setResource(w, Locale.ATTR_TYPES, keysValidate, f.getValue(), null, true);
				b = true;
			}

			if (b && uomId === null) {
				w.changeNode(this.m_urlNode).changeAttribute(BusinessObject.ATTR_MODIFIED, xml.ATTR_BOOLEAN, true);
			}

			// apply validation rule on initial value if entered
			if (bValidate && fd.getFieldValue("ValidationExpression") && fd.getFieldValue("Format") != "Rich" && this._isRegularAttribute(uomId, id)) { // DE30377: Rich text format has no initial value
				this.ivErrorCode = keysValidate.join(".");
				this.m_writer.callMethod("Reflection", "ValidateInitialValue").addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode);
			}
		},

        convertInitialValueToJSON: function(type,value) {
            // convert value to JSON appropriately
            if (type == xml.ATTR_TIME) {
                value = new Date(value || 0);
            }
            return JSON.stringify(value);
        },

        toWriterBase: function(url) {
            // summary: Create a custom attribute and add it to the business object
			var	fd = this.m_formData;
            var	type = fd.getFieldValue(reflection.ATTR_VALUETYPE);
            var	value = fd.getFieldValue(reflection.ATTR_VALUE, true) || xml.attributeTypeGetDefaultValue(type);

			this.m_urlNode = url;

			this.createAttribute(type, value);
			this.toWriterLocale(true);

			return true;
		},

		createAttribute(type, value, suffix = "") {
			var	fd = this.m_formData;
            var	id = fd.getFieldValue(xml.ATTR_NAME) + suffix;

			this.m_writer.callMethod("Reflection", "CreateCustomAttribute")
				.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlParent)
				.addParameter(xml.PROP_ID, xml.ATTR_STRING, id);

            // convert value to JSON appropriately
            value = this.convertInitialValueToJSON(type,value);
            var cn = this.m_writer.changeNode(this.m_urlNode + suffix)
                .changeAttribute(reflection.ATTR_VALUE, xml.ATTR_STRING, value)
                .changeAttribute(BusinessObject.ATTR_ATTRIBUTE_FLAGS, xml.ATTR_INT64, this.getAttributeFlags(fd));

			// write attributes related to subtypes/references
			this.changeSubtypeAndFormat(cn, type);

			// Set copy related attributes
			var allCopyCategory = fd.AllCopyCategory;
			var copyOptionName = fd.getFieldValue(reflection.ATTR_COPY_OPTION_NAME, true);

			if (allCopyCategory && (allCopyCategory != xml.enumCreate("CopyCategory"))) {
				cn.changeAttribute(reflection.ATTR_COPY_CATEGORIES, xml.ATTR_ENUMMAP, {"All": allCopyCategory});
				cn.changeAttribute(reflection.ATTR_COPY_OPTION_NAME, xml.ATTR_STRING, copyOptionName);
			}

			cn.changeAttribute(reflection.ATTR_EXP_ONCLIENT_DISABLED, xml.ATTR_BOOLEAN, !fd.getFieldValue(BusinessObject.ATTR_EXP_ONCLIENT_ENABLED))
				.changeAttributeFlag(reflection.ATTR_EXP_ONCLIENT_DISABLED, xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);

			// handle the "ColumnWidth"
			this._handleColumnWidth(fd, false);

			this.toWriterFields(this.m_urlNode + suffix);
		},

		/**
		 * Apply Bulidin CopyOptions to change node when doing a NewFromInherited BO or editing a BO Custom Attribute
		 * @param {FormData} fd
		 * @param var cn - changeNode request
		 * @param var sourceNode
		 */
		applyBuildInAttributesCopyOption: function(fd, cn, sourceNode) {
			// write copy related attributes
			var allCopyCategory = fd.AllCopyCategory;
			if (allCopyCategory != fd.InitialAllCopyCategory) {
				var mapValue = {};
				var copyCategories = xml.nodeGetAttributeValue(sourceNode, reflection.ATTR_COPY_CATEGORIES);
				csi.applyForEach(copyCategories, function(catValue, catKey) {
					mapValue[catKey] = catValue;
				});

				if (allCopyCategory && (allCopyCategory != xml.enumCreate("CopyCategory"))) {
					mapValue["All"] = allCopyCategory;
				} else if (mapValue["All"] != null) {
					mapValue["All"] = null;
				}
				cn.changeAttribute(reflection.ATTR_COPY_CATEGORIES, xml.ATTR_ENUMMAP, mapValue)
					.changeAttributeFlag(reflection.ATTR_COPY_CATEGORIES, xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);
			}

			if (fd.isFieldChanged(reflection.ATTR_COPY_OPTION_NAME)) {
				cn.changeAttribute(reflection.ATTR_COPY_OPTION_NAME, xml.ATTR_STRING, fd.getFieldValue(reflection.ATTR_COPY_OPTION_NAME, true))
					.changeAttributeFlag(reflection.ATTR_COPY_OPTION_NAME, xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);
			}
		},

		/**
		 * @override
		 * Return custom error message if validation failed
		 */
		getError: function(suffix, params) {
			if (this._errorCode == this.ivErrorCode) {
				return locale.resource("CustomAttribute_ErrorInitialValueDoesntFulfillValidationExpression");
			}

			return this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// summary: apply changes to localization resources from this form
			Locale.flushResources();
			this.inherited(arguments);
		},

		/**
		 * @override
		 * cache the related derived BO nodes as well as the base BO nodes, to be able to validate the value type
		 */
		onPreActionDeferreds(dfds) {
			const bo = this.widget.getViewNode();
			const cache = this.widget.getCache();
			const setUrls = new Set();

			bo.RelatedClassNames.forEach((clsName) => {
				const currentRC = reflection.getClass(clsName);
				currentRC.traverse(false, true, function(rc) {
					if (rc == currentRC) {
						return;
					}
						
					const boUrl = rc.getBusinessObject();

					if (boUrl) {
						setUrls.add(boUrl);
					}
				});
			});

			const dfd = resolveNodes([...setUrls], cache);
			const dfd2 =  this._getBaseClassesRecursively(bo.BaseBusinessObjects);

			dfds.push(dfd, dfd2);
		},

		_getBaseClassesRecursively(boUrls) {
			return new Promise((resolve, reject) => {
				if (boUrls.length==0) {
					resolve();
					return;
				}

				const cache = this.widget.getCache();
				const promiseList = [];

				resolveNodes(boUrls, cache).then((bos)=>{
					bos.forEach((bo) => {
						promiseList.push(this._getBaseClassesRecursively(bo.BaseBusinessObjects));
					});

					Promise.all(promiseList).then(() => {
						resolve();
					});
				});
			});
		},

		/**
		 * Return false if this attribute is a UOM conversion attribute
		 */
		_isRegularAttribute(/*UOMConversionId | UOMName*/uomId, /*String*/id) {
			return uomId === null || id.substring(id.length - UOM_SUFFIX.length) !== UOM_SUFFIX;
		},
	});
});